import React, { PureComponent } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import libphonenumber from 'google-libphonenumber';
import { Form, Input, Button, Row, Col, Select } from 'antd';
import { FormattedMessage } from "react-intl";
import countryList from 'react-select-country-list';
import { cc, cf, cw, hp } from '../../utils';

import AuthHeader from './Header';
import { getCookie } from '../../utils/helpers';

class SignUp extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            country: {
                location: {},
                country_name: 'Ghana',
                country_code: ''
            },
            countries: countryList().getData(),
            recaptcha: null, screen: 0,
        };
    }

    componentDidMount() {
        const { _auth: { authenticated } } = this.props;
        if (authenticated) {
            window.location.assign(process.env.REACT_APP_SUCCESS_REDIRECT);
            return;
        }
        this.ipinfo();
    }

    ipinfo = () => {
        axios({
            method: 'POST',
            url: `${hp.getApiBaseUrl()}/ipinfo`,
            json: true
        }).then((res) => {
            if (res.data.country_name) {
                this.setState({ country: res.data, fetching: false });
            }
        }).catch((err) => {
            this.setState({ fetching: false });
        });
    }

    onChangeRecap = value => {
        this.setState({ recaptcha: value });
    };

    asyncAvailable = async (name, value) => {
        return await axios({
            method: 'GET',
            url: `${hp.getApiBaseUrl()}/auth/validations/${name}s/${value}`,
            json: false
        }).then((res) => {
            if (res.data.statusCode === 200) {
                return res.data.data.userExists;
            } else {
                return false;
            }
        }).catch((err) => {
            return false;
        });
    };

    chheckEmailAddress = async (rule, value, callback) => {
        if (!value) {
            callback();
        }
        if (value) {
            var checker = await this.asyncAvailable('email', value);
            if (checker === true) {
                callback(`${value} already exists`);
            } else {
                callback();
            }
        }
    }

    checkNumber = phone => {
        try {
            return libphonenumber.PhoneNumberUtil.getInstance().isPossibleNumber(
                libphonenumber.PhoneNumberUtil.getInstance().parse(phone, '')
            );
        } catch (error) {
            return false;
        }
    };

    isPhoneNumber = phone => {
        try {
            return libphonenumber.PhoneNumberUtil.getInstance().isValidNumber(libphonenumber.PhoneNumberUtil.getInstance().parse(phone, ''));
        } catch (error) {
            return false;
        }
    };

    checkPhoneNumber = async (rule, value, callback) => {
        const { form: { getFieldValue } } = this.props;
        const num = this.isPhoneNumber(`${getFieldValue('prefix')}${value}`);
        const state = this.checkNumber(`${getFieldValue('prefix')}${value}`);

        const newPhone = `${getFieldValue('prefix')}${value.replace(/^0/, '')}`;
        const checker = await this.asyncAvailable('msisdn', newPhone.trim());
        if (checker === true) {
            callback(`${value} already exists`);
        }
        if (!value) {
            callback();
        }
        if (!num) {
            callback(this.props.intl.formatMessage(cw.formErrorMsgNotValidPhoneNumber));
        }
        if (!state) {
            callback(this.props.intl.formatMessage(cw.formErrorMsgNotValidPhoneNumber));
        }
        callback();
    };

    confirmPassword = (rule, value, callback) => {
        if (!value) {
            callback();
        }
        if (value !== this.props.form.getFieldValue('password')) {
            callback(this.props.intl.formatMessage(cw.formErrorMsgMismatchPassword));
        }
        callback();
    };

    getStarted = e => {
        e.preventDefault();
        const { form: { validateFieldsAndScroll } } = this.props;
        validateFieldsAndScroll(['organizationName', 'industry'], (err) => {
            if (!err) {
                this.setState({ screen: 1 });
            }
        });
    }

    _signup = e => {
        e.preventDefault();
        const { form: { validateFields, getFieldValue }, signUp, intl, _utils: { lang } } = this.props;
        const newPhone = `${getFieldValue('prefix')}${getFieldValue('msisdn').replace(/^0/, '')}`;
        validateFields((err, v) => {
            if (!err) {
                signUp(intl, lang, {
                    firstName: v.firstName,
                    lastName: v.lastName,
                    email: v.email.trim(),
                    msisdn: newPhone.trim(),
                    userCountry: v.country,
                    organizationName: v.firstName + ' ' + v.lastName,
                    industry:v.lastName,
                    organizationCountry: v.country,
                    password: v.password,
                    preferences: { language: lang, promoCode: getCookie('promoCode', true), }
                });
            }
        });
    };

    render() {
        const { form: { getFieldDecorator, getFieldsValue }, _utils, _auth: { signingIn, authenticated } } = this.props;

        if (authenticated) {
            return null;
        }

        const prefixSelector = getFieldDecorator('prefix', {
            initialValue: `+${this.state.country.location && this.state.country.location.calling_code
                ? this.state.country.location.calling_code
                : '233'}`
        })(
            <Select size="large" placeholder="+233" showSearch style={{ width: '6vw' }}
                onChange={e => {
                    this.props.form.setFields({
                        country: {
                            value: cc.find(country => country.dialCode === e).name
                        }
                    });
                }}
            >
                {cc.map(country => (
                    <Select.Option key={country.countryCode} value={country.dialCode}>
                        {country.dialCode}
                    </Select.Option>
                ))}
            </Select>
        );

        return (
            <React.Fragment>
                <Form id="esoko__signin" hideRequiredMark={true} onSubmit={this._signup}>
                    <AuthHeader screen="signup" />

                    {/* Personal details */}
                    <Row gutter={16}>
                        <Col span={24}>
                            <p><b><FormattedMessage id="Signup.Title.Personal" defaultMessage="Enter your personal details" /></b></p>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.FirstName" defaultMessage="First Name" />}>
                                    {getFieldDecorator('firstName', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.FirstName.Required" defaultMessage="Please provide first name" /> }
                                        ]
                                    })(
                                        <Input size="large" type="text" autoComplete="off" sso-id="signup-firstname" />
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <Form.Item colon={false} label={<FormattedMessage id="Label.LastName" defaultMessage="Last Name" />}>
                                    {getFieldDecorator('lastName', {
                                        rules: [
                                            { required: true, message: <FormattedMessage id="Rules.LastName.Required" defaultMessage="Please provide last name" /> }
                                        ]
                                    })(
                                        <Input size="large" type="text" autoComplete="off" sso-id="signup-lastname" />
                                    )}
                                </Form.Item>
                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.EmailAddress" defaultMessage="Email Address" />}>
                                {getFieldDecorator('email', {
                                    validate: [
                                        {
                                            trigger: 'onBlur',
                                            rules: [{ validator: this.chheckEmailAddress }]
                                        },
                                        {
                                            trigger: 'onChange',
                                            rules: [
                                                { required: true, message: <FormattedMessage id="Rules.EmailAddress.Required" defaultMessage="Please provide email address" /> },
                                                { type: 'email', message: <FormattedMessage id="Rules.EmailAddress.Invalid" defaultMessage="Please check provided email" /> }
                                            ]
                                        }
                                    ]
                                })(
                                    <Input size="large" type="email" autoComplete="off" sso-id="signup-email" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.PhoneNumber" defaultMessage="Phone Number" />}>
                                {getFieldDecorator('msisdn', {
                                    rules: [
                                        { required: true, message: <FormattedMessage id="Rules.PhoneNumber.Required" defaultMessage="Please provide phone number" /> },
                                        { validator: this.checkPhoneNumber, trigger: 'onBlur' }
                                    ]
                                })(
                                    <Input size="large" type="number" addonBefore={prefixSelector} autoComplete="off" sso-id="signup-msisdn" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.Country" defaultMessage="Country" />}>
                                {getFieldDecorator('country', {
                                    rules: [
                                        { required: true, message: <span /> },
                                    ],
                                    initialValue: 'Ghana'
                                })(
                                    <Select size="large" showSearch={true} sso-id="signup-userCountry">
                                        {this.state.countries.map(cnt => (
                                            <Select.Option key={cnt.label} value={cnt.label}>{cnt.label}</Select.Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.Password" defaultMessage="Password" />}>
                                {getFieldDecorator('password', {
                                    rules: [
                                        { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                        { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> }
                                    ]
                                })(
                                    <Input.Password size="large" type="password" minLength="6" autoComplete="off" sso-id="signup-password" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item colon={false} label={<FormattedMessage id="Label.ConfirmPassword" defaultMessage="Confirm Password" />}>
                                {getFieldDecorator('cpassword', {
                                    rules: [
                                        { required: true, message: <FormattedMessage id="Rules.Password.Required" defaultMessage="Please provide password" /> },
                                        { min: 6, message: <FormattedMessage id="Rules.Password.Min6" defaultMessage="Password must be at least 6 characters" /> },
                                        { validator: this.confirmPassword }
                                    ]
                                })(
                                    <Input.Password size="large" type="password" minLength="6" autoComplete="off" sso-id="signup-confirmPassword" />
                                )}
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <div className="recaptchaDiv">
                                <ReCAPTCHA data-size="compact" ref="recaptcha" size="invisible" sitekey={cf.REACT_RECAPTCHA_SITE_KEY} onChange={this.onChangeRecap} />
                            </div>
                        </Col>
                        <Col span={24}>
                            <Form.Item>
                                <Button className="submitBtn" block size="large" type="primary" htmlType="submit" loading={signingIn} sso-id="signup-button">
                                    <FormattedMessage id="Button.SIgnup" defaultMessage="Sign up" />
                                </Button>
                            </Form.Item>
                        </Col>
                        {/* <Col span={24} style={{ textAlign: 'center' }}>
                            <p><a href={`/${_utils.lang || 'en'}/signup${window.location.search}#changedetails`} onClick={() => this.setState({ screen: 0 })}>Change Organization Details</a></p>
                        </Col> */}
                    </Row>

                    <div className="formLinks">
                        <p style={{ textAlign: 'center' }}>
                            <span className="noAccountText"><FormattedMessage id="auth_signin_got_account" defaultMessage="Already have an account?" /></span>
                            <Link to={`/${_utils.lang || 'en'}/signin${window.location.search}`} sso-id="login-link"><FormattedMessage id="auth_signin_signin" defaultMessage="Sign in" /></Link>
                        </p>
                    </div>
                </Form>
            </React.Fragment>
        );
    }
}

const SignUpForm = Form.create({ name: 'signup' })(SignUp);
export default SignUpForm;